import SectionProvider from '@builder/sections/SectionProvider'

export const name = 'Post Title'
export const group = 'Dynamic blog'
export const beta = false

export const defaultOptions = {
  content: {
    data: {
      post: '',
      type: 'featured-post-title-mod',
      maxWords: null
    }
  }
}

export const icon = ''

export default class ElPostCategories extends SectionProvider {
  constructor (options = {}) {
    super('ElFeaturedPostTitle', options)

    this.name = name
    this.group = group
    this.defaultOptions = defaultOptions
  }
}
